const RowLink = (($) => {

    const NAME = 'rowlink';
    const DATA_KEY = `bs.${NAME}`;
    const EVENT_KEY = `.${DATA_KEY}`;
    const DATA_API_KEY = '.data-api';
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {
        rowlink: 'a'
    };
    const Event = {
        CLICK: `click${EVENT_KEY}`,
        MOUSEUP: `mouseup${EVENT_KEY}`,
        CLICK_DATA_API: `click${EVENT_KEY}${DATA_API_KEY}`,
        MOUSEUP_DATA_API: `mouseup${EVENT_KEY}${DATA_API_KEY}`
    }
    const Selector = {
        CLASS_NAME: `.js-${NAME}`
    };

    class RowLink {
        constructor(element, config) {
            this._config = config;
            this._element = element;

            $(this._element).on(`${Event.CLICK} ${Event.MOUSEUP}`, 'td:not(.rowlink-skip)', (e, ctrlKey) => this._click(e, ctrlKey));
        }

        _click(e, ctrlKey) {
            const target = $(e.currentTarget).closest('tr').find(this._config.rowlink)[0];

            if ($(e.target)[0] === target) {
                return;
            }
            if (e.type === 'mouseup' && e.which !== 2) {
                return;
            }

            e.preventDefault();
            ctrlKey = ctrlKey || e.ctrlKey || (e.type === 'mouseup' && e.which === 2);

            if (!ctrlKey && target.click) {
                target.click();
            } else if (document.createEvent) {
                const evt = document.createEvent("MouseEvents");
                evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, ctrlKey, false, false, false, 0, null);
                target.dispatchEvent(evt);
            }
        }

        dispose() {
            $.removeData(this._element, DATA_KEY);
            this._config = null;
            this._element = null;
        }


        static _jQueryInterface() {
            return this.each(function () {
                const $this = $(this);
                let data = $this.data(DATA_KEY);
                const config = $.extend({}, Default, $this.data());
                if (!data) {
                    data = new RowLink(this, config);
                    $this.data(DATA_KEY, data);
                }
            });
        }
    }

    $(document).on(`${Event.CLICK_DATA_API} ${Event.MOUSEUP_DATA_API}`, Selector.CLASS_NAME, function (e) {
        if (e.type === 'mouseup' && e.which !== 2) {
            return;
        }
        if ($(e.target).closest('.rowlink-skip').length !== 0) {
            return;
        }

        if ($(this).data(DATA_KEY)) {
            return;
        }
        RowLink._jQueryInterface.call($(this));

        const ctrlKey = e.ctrlKey || e.which === 2;
        $(e.target).trigger(Event.CLICK, [ctrlKey]);
    });

    $.fn[NAME] = RowLink._jQueryInterface;
    $.fn[NAME].Constructor = RowLink;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return RowLink._jQueryInterface;
    }

    return RowLink;
})(jQuery);